import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import ProjectSlider from './projectslider';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Finance() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const brandData = [
    { id: 1, image: '/assets/img/brand_img01.png' },
    { id: 2, image: '/assets/img/brand_img02.png' },
    { id: 3, image: '/assets/img/brand_img03.png' },
    { id: 4, image: '/assets/img/brand_img04.png' },
    { id: 5, image: '/assets/img/brand_img05.png' },
    { id: 6, image: '/assets/img/brand_img02.png' },
  ];


  
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };

  const handlePrev = () => {
    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };
  const testimonials = [
    {
      name: "David Anderson",
      position: "Supply Chain Director, Global Trade Solutions",
      rating: 5,
      comment: "MTL Ship has revolutionized our international shipping operations. Their expertise in handling complex logistics challenges and commitment to on-time delivery has significantly improved our supply chain efficiency."
    },
    {
      name: "Maria Rodriguez",
      position: "Operations Manager, TechForward Inc.",
      rating: 5,
      comment: "The team's attention to detail and proactive communication have made them an invaluable partner. Their real-time tracking system gives us complete visibility of our shipments worldwide."
    },
    {
      name: "James Wilson",
      position: "CEO, Oceanic Trading Co.",
      rating: 5,
      comment: "Working with MTL has been a game-changer for our business. Their innovative solutions and customer-first approach have helped us expand our operations across new markets with confidence."
    },
    {
      name: "Sarah Chen",
      position: "Logistics Coordinator, Asian Markets Ltd",
      rating: 5,
      comment: "MTL's expertise in handling sensitive cargo and their ability to navigate complex customs procedures have made them our preferred logistics partner in the region."
    }
  ];
  const renderStars = (rating) => {
    return Array(rating).fill().map((_, index) => (
      <i key={index} className="fas fa-star" />
    ));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    try {
      const response = await fetch('https://excel.progressytems.com/api/v1/apx/sendmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subject: 'New Contact Form Submission',
          text: `
            Name: ${formData.name}
            Email: ${formData.email}
            Phone: ${formData.phone}
            Subject: ${formData.subject}
            Message: ${formData.message}
          `
        })
      });

      if (response.ok) {
        toast.success('Message sent successfully!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        toast.error('Failed to send message. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
      <div id="preloader" style={{ display: "none" }}>
        <div className="tg-preloader-block">
          <div className="tg-spinner-eff">
            <div className="tg-bar tg-bar-top" />
            <div className="tg-bar tg-bar-right" />
            <div className="tg-bar tg-bar-bottom" />
            <div className="tg-bar tg-bar-left" />
          </div>
        </div>
      </div>
      {/*Preloader-end */}
      {/* Scroll-top */}
      <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>
      {/* Scroll-top-end*/}
      {/* header-area */}
          <HeaderBest />
      {/* header-area-end */}
      {/* main-area */}
      <main className="fix">

        {/* banner-area */}
        <section
          className="banner__area banner__bg"
          data-background="assets/img/banner_bg.jpg"
          style={{ backgroundImage: 'url("assets/img/banner_bg.jpg")' }}
        >
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-6">
                <div className="banner__content">
                  <span
                    className="sub-title aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    Fastest &amp; Secure Logistics
                  </span>
                  <h2
                    className="title aos-init aos-animate"
                    data-aos="fade-up"
                    data-aos-delay={400}
                  >
                    We Deliver your Product Anywhere!
                  </h2>
                  <p
                    data-aos="fade-up"
                    data-aos-delay={600}
                    className="aos-init aos-animate"
                  >
  With a vision for the future, our company strives to move goods smarter, faster, and more efficiently every day.              </p>
  <Link className='btn aos-init aos-animate' to="/services">
           
                    Explore Our Services{" "}
                   
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="banner__img">
                  <img
                    src="assets/img/banner_img02.png"
                    alt="img"
                    data-aos="fade-left"
                    data-aos-delay={800}
                    className="aos-init aos-animate"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="banner__shape-wrap">
            <img
              src="assets/img/banner_shape.png"
              alt="shape"
              className="rotateme"
            />
            <img
              src="assets/img/banner_img03.png"
              alt="img"
              className="wow bounceInDown"
              data-wow-delay=".3s"
              style={{
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "bounceInDown"
              }}
            />
          </div>
        </section>
        {/* banner-area-end */}
        {/* about-area */}
        <section className="about__area pt-120 pb-120">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-6 col-md-8">
                <div className="about__img">
                  <img src="/assets/img/about_img01.png" alt="img" />
                  <img
                    src="assets/img/about_img02.png"
                    alt="img"
                    data-aos="fade-right"
                    data-aos-delay={200}
                    className="aos-init aos-animate"
                  />
                  <img
                    src="assets/img/about_img03.png"
                    alt="img"
                    data-aos="fade-down"
                    data-aos-delay={400}
                    className="aos-init aos-animate"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about__content">
                  <div className="section__title mb-15">
                    <span className="sub-title">
                      Reliable Logistic &amp; Transport Solutions
                    </span>
                    <h2 className="title">
                      Delivering the Full Range <br /> Of logistics solutions
                    </h2>
                  </div>
                  <p>
                    At MTL Ship, we're not just moving cargo - we're moving businesses forward. With our innovative approach and commitment to excellence, we transform logistics challenges into opportunities for growth. Our team of experts ensures that every shipment, no matter the size or destination, receives the attention and care it deserves.
                  </p>
                  <div className="about__content-bottom">
                    <div className="about__list-box-wrap">
                      <div className="about__list-box">
                        <ul className="list-wrap">
                          <li>
                            <i className="flaticon-check" />
                            Quality Control System
                          </li>
                          <li>
                            <i className="flaticon-check" />
                            100% Satisfaction Guarantee
                          </li>
                          <li>
                            <i className="flaticon-check" />
                            Professional and Qualified
                          </li>
                          <li>
                            <i className="flaticon-check" />
                            Safe, Reliable And Express
                          </li>
                        </ul>
                      </div>
                      <Link to="/contact" className="btn">
                     
                        Get in Touch{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/icon/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        </Link>
                    </div>
                 
                  </div>
                  <div className="shape">
                    <img
                      src="assets/img/about_shape.png"
                      alt="shape"
                      data-aos="fade-left"
                      data-aos-delay={1000}
                      className="aos-init aos-animate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* about-area-end */}
        {/* brand-area */}
        {/* <div className="brand__area">

          <div className="container">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={30}
                  slidesPerView={5}
                  loop={true}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 2,
                    },
                    480: {
                      slidesPerView: 3,
                    },
                    768: {
                      slidesPerView: 4,
                    },
                    992: {
                      slidesPerView: 5,
                    },
                  }}
                  className="brand-active"
                >
                  {brandData.map((brand) => (
                    <SwiperSlide key={brand.id}>
                  <div className="brand__item">
                        <img src={brand.image} alt="brand" />
                  </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
          </div>
        </div>
        */}
        {/* brand-area-end */}
        {/* services-area */}
        <section className="services__area fix">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <div className="section__title mb-40">
                  <span className="sub-title">OUR BEST SERVICES</span>
                  <h2 className="title">
                    Covering All Logistics <br /> Solutions For you
                  </h2>
                </div>
              </div>
              <div className="col-md-4">
                <div className="view-all-btn text-end mb-40">
                  <a href="/services" className="btn btn-two">
                    All Services{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div className="row gutter-24 justify-content-center">
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="services__item">
                  <div className="services__thumb-wrap">
                    <div className="services__thumb">
                      <img src="/assets/img/services_img01.jpg" alt="img" />
                      <a
                        href="/services"
                        className="btn btn-two border-btn"
                      >
                        Read More{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="services__icon">
                      <i className="flaticon-ship" />
                    </div>
                  </div>
                  <div className="services__content">
                    <h3 className="title">
                    <Link to="/services">Ocean Freight</Link>
                    </h3>
                    <p>
                      Cost-effective and reliable ocean freight solutions for global trade. We ensure safe and timely delivery of your cargo worldwide with expert customs handling.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="services__item">
                  <div className="services__thumb-wrap">
                    <div className="services__thumb">
                      <img src="/assets/img/services_img02.png" alt="img" />
                      <a
                        href="/services"
                        className="btn btn-two border-btn"
                      >
                        Read More{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="services__icon">
                      <i className="flaticon-truck" />
                    </div>
                  </div>
                  <div className="services__content">
                    <h3 className="title">
                    <Link to="/services">Road Freight</Link>
                    </h3>
                    <p>
                      Efficient and flexible road freight solutions for domestic and international transport. We ensure timely delivery with our modern fleet and experienced drivers.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="services__item">
                  <div className="services__thumb-wrap">
                    <div className="services__thumb">
                      <img src="/assets/img/services_img03.png" alt="img" />
                      <a
                        href="/services"
                        className="btn btn-two border-btn"
                      >
                        Read More{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="services__icon">
                      <i className="flaticon-air-freight" />
                    </div>
                  </div>
                  <div className="services__content">
                    <h3 className="title">
                    <Link to="/services">Air Freight</Link>
                    </h3>
                    <p>
                      Fast and efficient air freight services for time-sensitive shipments. We ensure secure and reliable delivery to global destinations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="services__item">
                  <div className="services__thumb-wrap">
                    <div className="services__thumb">
                      <img src="/assets/img/services_img04.png" alt="img" />
                      <a
                        href="/services"
                        className="btn btn-two border-btn"
                      >
                        Read More{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/icon/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </div>
                    <div className="services__icon">
                      <i className="flaticon-train" />
                    </div>
                  </div>
                  <div className="services__content">
                    <h3 className="title">
                    <Link to="/services">Train Freight</Link>
                    </h3>
                    <p>
                      Cost-effective train freight services for bulk cargo. We provide reliable rail transportation across North America with secure handling and tracking.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="services__shape-wrap">
            <img
              src="assets/img/services_shape01.png"
              alt="shape"
              className="rotateme"
            />
            <img
              src="assets/img/services_shape02.png"
              alt="shape"
              data-aos="fade-right"
              data-aos-delay={400}
              className="aos-init"
            />
          </div>
        </section>
        {/* services-area-end */}
        {/* choose-area */}
        <section
          className="choose__area choose__bg"
          data-background="assets/img/vector_bg.svg"
          style={{ backgroundImage: 'url("assets/img/vector_bg.svg")' }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-lg-5 col-md-10">
                <div
                  className="choose__img wow "
           
                >
                  <img src="/assets/img/choose_img01.jpg" alt="img" />
                </div>
              </div>
              <div className="col-lg-7">
                <div className="choose__content">
                  <div className="section__title white-title mb-25">
                    <span className="sub-title">Why Choose Us</span>
                    <h2 className="title">
                      We are logistics improving <br /> our skills to fulfill
                      delivery <br /> of any level!
                    </h2>
                  </div>
                  <div className="choose__content-bottom">
                    <div className="left-side">
                      <p>
                      MTL Ship grows  mastering sea and air freight with global strength!
From fast air cargo to steady sea shipments, we deliver with confidence.
Reliable service, smart logistics, and nonstop movement define us.
Your cargo, across skies and seas  powered by MTL.
                      </p>
                      <Link to="/aboutus" className="btn white-btn">
                        To know more About Us{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        </Link>
                    </div>
             
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* choose-area-end */}
        {/* achieved-area */}
        <section className="achieved__area fix">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-10 order-0 order-lg-2">
                <div className="achieved__img">
                  <img
                    src="assets/img/achieved_img2.png"
                    alt="img"
                    className="wow bounceInDown"
                    data-wow-delay=".3s"
                    style={{
                      visibility: "hidden",
                      animationDelay: "0.3s",
                      animationName: "none"
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="achieved__content">
                  <div className="section__title mb-20">
                    <h2 className="title">
                    MTL Ship connecting continents by sea and air with precision!
                    </h2>
                  </div>
                  <p>
                  From time-critical flights to steady ocean freight, we deliver on promise.
Innovation, speed, and trust are at the heart of every move.
Across every route, your cargo flies and sails with MTL.
                  </p>
                  <div className="progress__wrap">
                  <Link to="/services" className="btn white-btn" style={{backgroundColor: 'red', color: 'white'}}>
                        See All Services{" "}
                        <svg
                          width={13}
                          height={13}
                          viewBox="0 0 13 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                          className="injectable"
                        >
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                            stroke="currentcolor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        </Link>
          
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="achieved__shape">
            <img src="/assets/img/achieved_shape.png" alt="shape" />
          </div>
        </section>
        {/* achieved-area-end */}
        {/* marquee-area */}
        <section className="marquee__area fix">
          <div className="container-fluid p-0">
            <div className="slider__marquee clearfix marquee-wrap">
              <div className="marquee_mode marquee__group">
                <div
                  style={{
                    width: 100000,
                    transform: "translateX(0px)",
                    animation:
                      "63.7714s linear 0s infinite normal none running marqueeAnimation-8896702"
                  }}
                  className="js-marquee-wrapper"
                >
                  <div
                    className="js-marquee"
                    style={{ marginRight: 0, float: "left" }}
                  >
                    <h6 className="marquee__item">
                      <Link to="/services">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Air Freight
                      </Link>
                    </h6>
                    <h6 className="marquee__item">
                      <Link to="/aboutus">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Logistics
                      </Link>
                    </h6>
                    <h6 className="marquee__item">
                      <Link to="/services">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Delivery Service
                      </Link>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/trackorder">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Tracking
                      </a>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/services">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Warehouse
                      </a>
                    </h6>
                  </div>
                  <div
                    className="js-marquee"
                    style={{ marginRight: 0, float: "left" }}
                  >
                    <h6 className="marquee__item">
                      <a href="/services">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Air Freight
                      </a>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/services">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Logistics
                      </a>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/contact">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Delivery Service
                      </a>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/trackorder">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Tracking
                      </a>
                    </h6>
                    <h6 className="marquee__item">
                      <a href="/services">
                        <svg
                          width={42}
                          height={42}
                          viewBox="0 0 42 42"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          data-inject-url="https://themeadapt.com/tf/logistex/assets/img/star.svg"
                          className="injectable"
                        >
                          <path
                            d="M15.8141 0.278544L12.447 1.42278L26.1388 41.7127L29.5059 40.5685L15.8141 0.278544Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M40.5588 12.4469L0.268867 26.1387L1.41311 29.5058L41.7031 15.814L40.5588 12.4469Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M39.2854 31.9752L40.8572 28.7853L2.68674 9.97769L1.11496 13.1677L39.2854 31.9752Z"
                            fill="currentcolor"
                          />
                          <path
                            d="M9.99785 39.2883L13.1878 40.8601L31.9954 2.68963L28.8054 1.11785L9.99785 39.2883Z"
                            fill="currentcolor"
                          />
                        </svg>{" "}
                        Warehouse
                      </a>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* marquee-area-end */}
        {/* project-area */}
        <section
          className="project__area project__bg"
          data-background="assets/img/bg/vector_bg02.svg"
          style={{ backgroundImage: 'url("assets/img/vector_bg02.svg")' }}
        >
          <div className="container">
            <div className="row align-items-end">
              <div className="col-lg-6 col-md-8">
                <div className="section__title mb-40">
                  <span className="sub-title">Featured Projects</span>
                  <h2 className="title">
                    We Are Proud to Excellence Deliver Success
                  </h2>
                </div>
              </div>
              <div className="col-lg-6 col-md-4">
                <div className="view-all-btn text-end mb-60">
                <Link to="/services" className="btn">
                    See All Services
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
          </div>
           
              <ProjectSlider />
        </section>
        {/* project-area-end */}
        {/* video-area */}
        <section className="video__area">
          <div
            className="video__bg"
            data-background="assets/img/video_bg.jpg"
            style={{ backgroundImage: 'url("assets/img/video_bg.jpg")' }}
          />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-7 col-lg-6 order-0 order-lg-2">
               
              </div>
              <div className="col-xl-5 col-lg-6">
                <div className="video__content">
                  <div className="section__title white-title">
                    <span className="sub-title">
                      Get Your Custom Offer
                    </span>
                    <h2 className="title">
                    Tell us more about your shipment                </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* video-area-end */}
        {/* request-area */}
        <div className="request__area" style={{marginBottom:40}}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="request__wrap">
                  <div className="request__nav">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                      <button
                          className={`nav-link ${isLoading ? 'disabled' : 'active'}`}
                          id="request-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#request-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="request-tab-pane"
                          aria-selected={!isLoading}
                          disabled={isLoading}
                        >
                          <i className="flaticon-big-box" />
                          {isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Gönderiliyor...
                            </>
                          ) : 'Request a Quote'}
                        </button>
                      </li>
      
                    </ul>
                  </div>
                  <div className="request__tab-wrap">
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane show active"
                        id="request-tab-pane"
                        role="tabpanel"
                        aria-labelledby="request-tab"
                        tabIndex={0}
                      >
                        <form onSubmit={handleSubmit} className="request__form">
                          <span className="title">Personal Data</span>
                          <div className="row gutter-20">
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <input 
                                  type="text" 
                                  name="name"
                                  value={formData.name}
                                  onChange={handleInputChange}
                                  placeholder="Name*" 
                                  required
                                  disabled={isLoading}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <input 
                                  type="email" 
                                  name="email"
                                  value={formData.email}
                                  onChange={handleInputChange}
                                  placeholder="Mail*" 
                                  required
                                  disabled={isLoading}
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <input 
                                  type="text" 
                                  name="phone"
                                  value={formData.phone}
                                  onChange={handleInputChange}
                                  placeholder="Phone*" 
                                  required
                                  disabled={isLoading}
                                />
                              </div>
                            </div>
                          </div>
                          <span className="title">Shipment Data</span>
                          <div className="row gutter-20">
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <div className="form-grp select-grp">
                                  <select 
                                    name="serviceType"
                                    value={formData.serviceType}
                                    onChange={handleInputChange}
                                    className="orderby"
                                    required
                                  >
                                    <option value="">Select Service Type</option>
                                    <option value="Economy">Economy</option>
                                    <option value="Time Critical">Time Critical</option>
                                    <option value="Express">Express</option>
                                    <option value="Couirier">Couirier</option>
                                    <option value="Sea Freight">Sea Freight</option>
                                    <option value="Airline Freight">Airline Freight</option>
                                    <option value="Road Freight">Road Freight</option>
                                    <option value="Foreign Freight">Foreign Freight</option>
                                    <option value="Transit Shipment">Transit Shipment</option>
                                    <option value="Value-Added Service">Value-Added Service</option>
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <input
                                  type="text"
                                  name="departureCity"
                                  value={formData.departureCity}
                                  onChange={handleInputChange}
                                  placeholder="City Of Departure"
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp">
                                <input 
                                  type="text" 
                                  name="deliveryCity"
                                  value={formData.deliveryCity}
                                  onChange={handleInputChange}
                                  placeholder="Delivery City" 
                                  required
                                />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp select-grp">
                                <select 
                                  name="incoterms"
                                  value={formData.incoterms}
                                  onChange={handleInputChange}
                                  className="orderby"
                                  required
                                >
                                  <option value="">Select Incoterms</option>
                                  <option value="EXW">EXW</option>
                                  <option value="FOB">FOB</option>
                                  <option value="FCA">FCA</option>
                                  <option value="DAP">DAP</option>
                                  <option value="DDP">DDP</option>
                                  <option value="CIF">CIF</option>
                                  <option value="CIP">CIP</option>
                                  <option value="CPT">CPT</option>
                                  <option value="CFR">CFR</option>
                                  <option value="FAS">FAS</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp-wrap">
                                <div className="form-grp">
                                  <input 
                                    type="text" 
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleInputChange}
                                    placeholder="Quantity" 
                                    required
                                  />
                                </div>
                                <div className="form-grp">
                                  <input 
                                    type="text" 
                                    name="width"
                                    value={formData.width}
                                    onChange={handleInputChange}
                                    placeholder="Width" 
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-grp-wrap">
                                <div className="form-grp">
                                  <input 
                                    type="text" 
                                    name="size"
                                    value={formData.size}
                                    onChange={handleInputChange}
                                    placeholder="Size" 
                                    required
                                  />
                                </div>
                                <div className="form-grp">
                                  <input 
                                    type="text" 
                                    name="height"
                                    value={formData.height}
                                    onChange={handleInputChange}
                                    placeholder="Height" 
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <button type="submit" className="btn" style={{marginTop:25}} disabled={isLoading}>
                            {isLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Gönderiliyor...
                              </>
                            ) : 'Request a Quote'}
                          </button>
                        </form>
                      </div>
                      <div
                        className="tab-pane"
                        id="track-tab-pane"
                        role="tabpanel"
                        aria-labelledby="track-tab"
                        tabIndex={0}
                      >
                        <form action="#" className="request__form">
                          <span className="title">Shipment Type</span>
                          <div className="form-grp select-grp">
                            <select name="interest" className="orderby">
                              <option value="Incoterms">Incoterms</option>
                              <option value="Incoterms">Incoterms</option>
                              <option value="Incoterms">Incoterms</option>
                            </select>
                          </div>
                          <span className="title">Tracking Number</span>
                          <div className="form-grp">
                            <textarea
                              name="comment"
                              placeholder="You can enter up to a maximum of 10 airway bill numbers for tracking"
                              defaultValue={""}
                            />
                          </div>
                          <div className="request__radio-wrap">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault5"
                                defaultChecked=""
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault5"
                              >
                                Air Freight
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault6"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault6"
                              >
                                Ocean Freight
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault7"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault7"
                              >
                                Road Freight
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault8"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault8"
                              >
                                Express Delivery
                              </label>
                            </div>
                          </div>
                          <button type="submit" className="btn">
                            Track &amp; Trace
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section
          className="work__area work__bg"
          data-background="assets/img/bg/vector_bg.svg"
          style={{ backgroundImage: 'url("assets/img/vector_bg.svg")' }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="section__title text-center white-title mb-50">
                  <span className="sub-title">HOW IT WORKS</span>
                  <h2 className="title">
                    How We Operate Unveiling <br /> Our Logistics Process
                  </h2>
                </div>
              </div>
            </div>
            <div className="work__item-wrap">
              <div className="row justify-content-center">
                <div className="col-lg-3 col-sm-6">
                  <div className="work__item">
                    <div className="work__icon">
                      <i className="flaticon-package" />
                      <span className="number">01</span>
                    </div>
                    <div className="work__content">
                      <h4 className="title">Request A Quote</h4>
                      <p>Contact us today to request a personalized quote tailored to your logistics needs.</p>
                    </div>
                    <div className="work__shape">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={98}
                        height={19}
                        viewBox="0 0 98 19"
                        fill="none"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/work_shape01.svg"
                        className="injectable"
                      >
                        <path
                          d="M0.476947 17.1477C0.00623465 17.4366 -0.141174 18.0523 0.1477 18.5231C0.436574 18.9938 1.05234 19.1412 1.52305 18.8523L0.476947 17.1477ZM97.1711 13.1209C97.7152 13.0264 98.0798 12.5087 97.9853 11.9646L96.4453 3.09729C96.3508 2.55315 95.8331 2.18864 95.289 2.28314C94.7448 2.37764 94.3803 2.89536 94.4748 3.4395L95.8436 11.3215L87.9616 12.6904C87.4175 12.7849 87.053 13.3026 87.1475 13.8467C87.242 14.3908 87.7597 14.7554 88.3038 14.6609L97.1711 13.1209ZM1.52305 18.8523C10.7198 13.2083 26.5465 6.12668 44.0511 3.27548C61.5562 0.424198 80.6124 1.82075 96.4243 12.9533L97.5757 11.318C81.1811 -0.224815 61.5277 -1.59753 43.7296 1.30149C25.9309 4.20059 9.86081 11.3889 0.476947 17.1477L1.52305 18.8523Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="work__item">
                    <div className="work__icon">
                      <i className="flaticon-support" />
                      <span className="number">02</span>
                    </div>
                    <div className="work__content">
                      <h4 className="title">Call Back From Office</h4>
                      <p>Contact us today to request a personalized quote tailored to your logistics needs.</p>
                    </div>
                    <div className="work__shape">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={98}
                        height={19}
                        viewBox="0 0 98 19"
                        fill="none"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/work_shape02.svg"
                        className="injectable"
                      >
                        <path
                          d="M0.476946 1.8523C0.00623321 1.56343 -0.141176 0.947661 0.147698 0.476948C0.436572 0.00623517 1.05234 -0.141174 1.52305 0.147699L0.476946 1.8523ZM97.1711 5.87907C97.7152 5.97357 98.0797 6.49128 97.9853 7.03542L96.4453 15.9027C96.3508 16.4468 95.8331 16.8113 95.289 16.7169C94.7448 16.6224 94.3803 16.1046 94.4748 15.5605L95.8436 7.67847L87.9616 6.30964C87.4175 6.21514 87.053 5.69742 87.1475 5.15328C87.242 4.60914 87.7597 4.24464 88.3038 4.33913L97.1711 5.87907ZM1.52305 0.147699C10.7198 5.79173 26.5465 12.8733 44.0511 15.7245C61.5562 18.5758 80.6124 17.1792 96.4243 6.04665L97.5757 7.68199C81.1811 19.2248 61.5277 20.5975 43.7296 17.6985C25.9309 14.7994 9.86081 7.61113 0.476946 1.8523L1.52305 0.147699Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="work__item">
                    <div className="work__icon">
                      <i className="flaticon-global-distribution" />
                      <span className="number">03</span>
                    </div>
                    <div className="work__content">
                      <h4 className="title">Delivery Available</h4>
                      <p>Fast and reliable delivery available to all major locations.</p>
                    </div>
                    <div className="work__shape">
                      <svg
                        width={98}
                        height={19}
                        viewBox="0 0 98 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/work_shape01.svg"
                        className="injectable"
                      >
                        <path
                          d="M0.476947 17.1477C0.00623465 17.4366 -0.141174 18.0523 0.1477 18.5231C0.436574 18.9938 1.05234 19.1412 1.52305 18.8523L0.476947 17.1477ZM97.1711 13.1209C97.7152 13.0264 98.0798 12.5087 97.9853 11.9646L96.4453 3.09729C96.3508 2.55315 95.8331 2.18864 95.289 2.28314C94.7448 2.37764 94.3803 2.89536 94.4748 3.4395L95.8436 11.3215L87.9616 12.6904C87.4175 12.7849 87.053 13.3026 87.1475 13.8467C87.242 14.3908 87.7597 14.7554 88.3038 14.6609L97.1711 13.1209ZM1.52305 18.8523C10.7198 13.2083 26.5465 6.12668 44.0511 3.27548C61.5562 0.424198 80.6124 1.82075 96.4243 12.9533L97.5757 11.318C81.1811 -0.224815 61.5277 -1.59753 43.7296 1.30149C25.9309 4.20059 9.86081 11.3889 0.476947 17.1477L1.52305 18.8523Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="work__item">
                    <div className="work__icon">
                      <i className="flaticon-parcel" />
                      <span className="number">04</span>
                    </div>
                    <div className="work__content">
                      <h4 className="title">Deliver Shipping</h4>
                      <p>We deliver fast and secure shipping solutions tailored to your business needs.</p>
                    </div>
                    <div className="work__shape">
                      <svg
                        width={98}
                        height={19}
                        viewBox="0 0 98 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/work_shape01.svg"
                        className="injectable"
                      >
                        <path
                          d="M0.476947 17.1477C0.00623465 17.4366 -0.141174 18.0523 0.1477 18.5231C0.436574 18.9938 1.05234 19.1412 1.52305 18.8523L0.476947 17.1477ZM97.1711 13.1209C97.7152 13.0264 98.0798 12.5087 97.9853 11.9646L96.4453 3.09729C96.3508 2.55315 95.8331 2.18864 95.289 2.28314C94.7448 2.37764 94.3803 2.89536 94.4748 3.4395L95.8436 11.3215L87.9616 12.6904C87.4175 12.7849 87.053 13.3026 87.1475 13.8467C87.242 14.3908 87.7597 14.7554 88.3038 14.6609L97.1711 13.1209ZM1.52305 18.8523C10.7198 13.2083 26.5465 6.12668 44.0511 3.27548C61.5562 0.424198 80.6124 1.82075 96.4243 12.9533L97.5757 11.318C81.1811 -0.224815 61.5277 -1.59753 43.7296 1.30149C25.9309 4.20059 9.86081 11.3889 0.476947 17.1477L1.52305 18.8523Z"
                          fill="currentcolor"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* work-area-end */}
        {/* blog-post-area */}
        <section className="blog__post-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-8">
                <div className="section__title mb-40">
                  <span className="sub-title">LATEST NEWS</span>
                  <h2 className="title">Our Recent Articles</h2>
                </div>
              </div>
              <div className="col-lg-6 col-md-4">
                <div className="view-all-btn text-end mb-40">
                <Link to="/blog" className="btn btn-two">
                    See All News{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="row justify-content-center gutter-24">
              <div className="col-lg-4 col-md-6">
                <div className="blog__post-item shine__animate-item">
                  <div className="blog__post-thumb">
                    <Link to="/blogdetails/4" className="shine__animate-link">
                      <img src="/assets/img/blog_img01.jpg" alt="img" />
                    </Link>
                  </div>
                  <div className="blog__post-content">
                    <div className="blog__meta">
                      <ul className="list-wrap">
                  
                      </ul>
                    </div>
                    <h3 className="title">
                      <Link to="/blogdetails/4">
                        Importers achieve savings through the First Sale rule!
                        </Link>
                    </h3>
                    <p>
                    Many importers are discovering significant cost savings by leveraging the First Sale rule a U.S.
                    </p>
                    <Link to="/blogdetails/4" className="btn btn-two">
                      Read More{" "}
                      <svg
                        width={13}
                        height={13}
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                        className="injectable"
                      >
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="blog__post-item shine__animate-item">
                  <div className="blog__post-thumb">
                    <Link to="/blogdetails/3" className="shine__animate-link">
                      <img src="/assets/img/h2_blog_img03.jpg" alt="img" />
                    </Link>
                  </div>
                  <div className="blog__post-content">
                    <div className="blog__meta">
                      <ul className="list-wrap">
                   
                      </ul>
                    </div>
                    <h3 className="title">
                    <Link to="/blogdetails/3">
                    Green Logistics Solutions for a Greener Future
                      </Link>
                    </h3>
                    <p>
                    As environmental concerns continue to grow, green logistics has emerged as a vital approach for building a more sustainable supply chain.
                    </p>
                    <Link to="/blogdetails/3" className="btn btn-two">
                      Read More{" "}
                      <svg
                        width={13}
                        height={13}
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                        className="injectable"
                      >
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="blog__post-item shine__animate-item">
                  <div className="blog__post-thumb">
                    <Link to="/blogdetails/5" className="shine__animate-link">
                      <img src="/assets/img/blog_img03.jpg" alt="img" />
                    </Link>
                  </div>
                  <div className="blog__post-content">
                    <div className="blog__meta">
                      <ul className="list-wrap">
                     
                      </ul>
                    </div>
                    <h3 className="title">
                    <Link to="/blogdetails/5">
                        Green Logistics Solutions for a Greener Future
                        </Link>
                        </h3>
                    <p>
                      Road transpo arere tation criucial roley area coordinated
                      trans portatn they aw countries destination.
                    </p>
                    <Link to="/blogdetails/5" className="btn btn-two">
                      Read More{" "}
                      <svg
                        width={13}
                        height={13}
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                        className="injectable"
                      >
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                          stroke="currentcolor"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* blog-post-area-end */}
        {/* contact-map */}
        <div className="contact-map">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3463.178600727177!2d-95.2789367220725!3d29.772476775061737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640bc79a0a1dddf%3A0x4b1926abca42a8dd!2s8451%20Market%20St%2C%20Houston%2C%20TX%2077029%2C%20Amerika%20Birle%C5%9Fik%20Devletleri!5e0!3m2!1str!2str!4v1743781395235!5m2!1str!2str"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
        {/* contact-map-end */}
      </main>
      {/* main-area-end */}
      {/* footer-area */}
      {showModal && (
            <div className={`custom-modal ${modalType}`}>
              <div className="modal-content">
                {modalMessage}
              </div>
            </div>
          )}
          <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>
      {/* footer-area-end */}
        </>
      );
    }

    export default Finance;


